import React from 'react';
import * as PropTypes from 'prop-types';

import { redirectToDependentForm } from '../../../utils/appointments/redirect-utils';
import Shape from '../../common/Shape';
import Icon from '../../Icon';
import { DEPENDENT_FORM_SUBMIT_REDIRECT } from '../../../constants';

function AddNewUser({ formatMessage, setDependentSubmitRedirect }) {
  const handleClick = () => {
    setDependentSubmitRedirect(DEPENDENT_FORM_SUBMIT_REDIRECT.GET_CARE);
    redirectToDependentForm();
  };

  return (
    <Shape
      renderLeft={() => <Icon name="add-new" size={40} />}
      onClick={handleClick}
      renderPrimary={() =>
        formatMessage({ id: 'appointments.form.step1.addNewPrimary' })
      }
      renderSecondary={() =>
        formatMessage({ id: 'appointments.form.step1.addNewSecondary' })
      }
    />
  );
}

AddNewUser.propTypes = {
  formatMessage: PropTypes.func,
  setDependentSubmitRedirect: PropTypes.func,
};

export default AddNewUser;



// WEBPACK FOOTER //
// ./src/components/AppointmentForm/AppointmentUsers/AddNew.jsx